import { useLocation, useNavigate } from "react-router-dom";
import "./HeaderFooterLayout.css";


export default function HeaderFooterLayout({ children }) {
  const location = useLocation();
  const navigate = useNavigate(); 



  return (
    <div className="page-wrapper">
        <header className="global-header">
          <div className="header-buttons">
            <div className="header-left">
            {location.pathname !== "/" && (
            <button
              className="back-button"
              style={{ marginLeft: "32px" }}
              onClick={() => {
                navigate("/");
              }}
            >
              ←
            </button>
          )}
          </div>
          </div>
          {location.pathname === "/" && (
            <>
              <div className="header-center">
                <h1 className="header-title">POD RECS</h1>
              </div>
              <div className="header-subcenter">
                <p className="header-subtitle">
                  Browse recs from your fave pods 🎧
                </p>
              </div>
            </>
          )}
        </header>
      <main>{children}</main>

      <footer className="global-footer">
        <p>Contact: steph@gorave.io</p>
      </footer>
    </div>
  );
}
